const consentAccepted = () => {
  try { return sessionStorage.getItem('viaturkey_cookie_consent') === 'accepted'; } catch { return false; }
};

export function trackWidgetEvent(name, props = {}) {
  if (!consentAccepted() || !window.__vtAnalyticsLoaded) return;
  const payload = { widget: 'chat', ...props };
  try { if (typeof window.gtag === 'function') window.gtag('event', name, payload); } catch {}
  try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, payload); } catch {}
}

const TOURS_EXACT = ['/tours', '/travel', '/private-istanbul-tours', '/istanbul-old-city-tour', '/layover-tours-istanbul', '/istanbul-tours-faq'];
const INVEST_TOURS = ['/tours/turkish-citizenship-investment', '/tours/real-estate-consulting'];

export function inferPathFromRoute(pathname) {
  const p = (pathname || '/').replace(/^\/(ar|ru|tr)(?=\/|$)/, '') || '/';
  if (p.startsWith('/real-estate') || INVEST_TOURS.includes(p)) return 'investment';
  if (TOURS_EXACT.includes(p) || p.startsWith('/tours/') || p.startsWith('/istanbul/')) return 'tours';
  return null;
}

export function istanbulOpenNow() {
  const hour = Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', hour: '2-digit', hour12: false }).format(new Date()));
  return hour >= 8 && hour < 22;
}
